<!-- Tabs Component - Only for Login/Register -->
@if (formMode === 'login' || formMode === 'register') {
  <app-login-register-tabs 
    [value]="formMode"
    [options]="loginRegisterOptions"
    (valueChange)="onTabChange($event)">
  </app-login-register-tabs>
}

<!-- Login Form Content -->
@if (formMode === 'login') {
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="login-mobile">Mobile Number</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput type="tel" id="login-mobile" placeholder="Enter Mobile Number" formControlName="mobile" required>
        @if (isFieldInvalid('mobile')) {
          <mat-error>{{ getFieldError('mobile') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="login-password">Password</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput [type]="showPassword ? 'text' : 'password'" id="login-password" placeholder="Enter Password" formControlName="password" required>
        <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button" aria-label="Toggle password visibility">
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (isFieldInvalid('password')) {
          <mat-error>{{ getFieldError('password') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group forgot-password-container">
      <button 
        type="button"
        class="forgot-password-link"
        (click)="onForgotPassword()">
        Forgot Password?
      </button>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="login-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Logging in...</span>
        } @else {
          <span>Login</span>
        }
      </button>
    </div>

    <div class="form-divider">
      <span class="divider-text">or</span>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="login-otp-link"
        (click)="onOtpLogin()">
        <span>Login with </span>
        <span class="otp-underline">OTP</span>
      </button>
    </div>
  </form>
}

<!-- Register Form Content -->
@if (formMode === 'register') {
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="register-name">Full Name</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput type="text" id="register-name" placeholder="Enter your full name" formControlName="name" required>
        @if (isFieldInvalid('name')) {
          <mat-error>{{ getFieldError('name') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="register-email">Email</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput type="email" id="register-email" placeholder="Enter your email" formControlName="email" required>
        @if (isFieldInvalid('email')) {
          <mat-error>{{ getFieldError('email') }}</mat-error>
        }
      </mat-form-field>
    </div>

        <div class="form-group">
      <label for="register-mobile">Mobile Number</label>
      <div class="mobile-input-container">
        <mat-form-field appearance="outline" class="form-field country-code-field" >
        
          <mat-select formControlName="countryCode"  (selectionChange)="onCountryCodeChange()">
            <mat-select-trigger>
              <span>{{ displayCountryCode(registerForm.get('countryCode')?.value) || '+91' }}</span>
            </mat-select-trigger>
            @for (country of bindcountryCodeDropDown; track country.countryCode) {
            <mat-option [value]="country.countryCode">
              {{ displayCountryCode(country.countryCode) }} - {{ country.countryName }}
            </mat-option>
            }
          </mat-select>
          
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field mobile-input-field">
          <input matInput type="tel" id="register-mobile" placeholder="Enter your mobile number" formControlName="mobile" required>
          @if (isFieldInvalid('mobile')) {
            <mat-error>{{ getFieldError('mobile') }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-group">
      <label for="register-password">Password</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput [type]="showRegisterPassword ? 'text' : 'password'" id="register-password" placeholder="Enter your password" formControlName="password" required>
        <button mat-icon-button matSuffix (click)="toggleRegisterPasswordVisibility()" type="button" aria-label="Toggle password visibility">
          <mat-icon>{{ showRegisterPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (isFieldInvalid('password')) {
          <mat-error>{{ getFieldError('password') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="register-confirm-password">Confirm Password</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput [type]="showConfirmPassword ? 'text' : 'password'" id="register-confirm-password" placeholder="Confirm your password" formControlName="confirmPassword" required>
        <button mat-icon-button matSuffix (click)="toggleConfirmPasswordVisibility()" type="button" aria-label="Toggle password visibility">
          <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (isFieldInvalid('confirmPassword')) {
          <mat-error>{{ getFieldError('confirmPassword') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="register-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Signing up...</span>
        } @else {
          <span>Sign Up</span>
        }
      </button>
    </div>
  </form>
}

<!-- OTP Login Form Content -->
@if (formMode === 'otpLogin') {
  <app-login-register-tabs 
    value="login"
    [options]="loginRegisterOptions"
    (valueChange)="onTabChange($event)">
  </app-login-register-tabs>
  
  <form [formGroup]="otpLoginForm" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="otp-login-mobile">Mobile Number</label>
      <div class="mobile-input-container">
        <mat-form-field appearance="outline" class="form-field country-code-field" >
        
          <mat-select formControlName="countryCode"  (selectionChange)="onCountryCodeChange()">
            <mat-select-trigger>
              <span>{{ displayCountryCode(otpLoginForm.get('countryCode')?.value) || '+91' }}</span>
            </mat-select-trigger>
            @for (country of bindcountryCodeDropDown; track country.countryCode) {
            <mat-option [value]="country.countryCode">
              {{ displayCountryCode(country.countryCode) }} - {{ country.countryName }}
            </mat-option>
            }
          </mat-select>
          
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field mobile-input-field">
          <input matInput type="tel" id="otp-login-mobile" placeholder="Enter your mobile number" formControlName="mobile" required>
          @if (isFieldInvalid('mobile')) {
            <mat-error>{{ getFieldError('mobile') }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="otp-login-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Sending OTP...</span>
        } @else {
          <span>Send OTP</span>
        }
      </button>
    </div>

    <div class="form-group instruction-text">
      <p>You will receive a One-Time Password (OTP) on your registered mobile number for verification.</p>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="back-to-login-link"
        (click)="onBackToLogin()">
        <span>Back to Login</span>
      </button>
    </div>
  </form>
}

<!-- Verify OTP Form Content -->
@if (formMode === 'verifyOtp') {
  <div class="form-header">
    <h3 class="form-title">Verify OTP</h3>
    <div class="form-divider"></div>
  </div>
  
  <form [formGroup]="verifyOtpForm" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="verify-otp-otp"> Enter OTP</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput type="text" id="verify-otp-otp" placeholder="Enter your 4 digit OTP" formControlName="otp" required maxlength="4">
        @if (isFieldInvalid('otp')) {
          <mat-error>{{ getFieldError('otp') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="verify-otp-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Verifying...</span>
        } @else {
          <span>Verify OTP</span>
        }
      </button>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="resend-otp-link"
        (click)="onResendOtp()">
        <span>Resend OTP</span>
      </button>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="back-to-login-link"
        (click)="onBackToLogin()">
        <span>Back to Login</span>
      </button>
    </div>
  </form>
}

<!-- Forgot Password Form Content -->
@if (formMode === 'forgotPassword') {
  <app-login-register-tabs 
    value="forgotPassword"
    [options]="forgotPasswordOptions"
    (valueChange)="onTabChange($event)">
  </app-login-register-tabs>
  
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="forgot-password-mobile">Mobile Number</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput type="tel" id="forgot-password-mobile" placeholder="Enter your mobile number" formControlName="mobile" required>
        @if (isFieldInvalid('mobile')) {
          <mat-error>{{ getFieldError('mobile') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="forgot-password-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Sending OTP...</span>
        } @else {
          <span>Send OTP</span>
        }
      </button>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="back-to-login-link"
        (click)="onBackToLogin()">
        <span>Back to Login</span>
      </button>
    </div>
  </form>
}

<!-- Forgot Password OTP Form Content -->
@if (formMode === 'forgotPasswordOtp') {
  <div class="form-header">
    <h3 class="form-title">Verify OTP</h3>
    <div class="form-divider"></div>
  </div>
  
  <form [formGroup]="forgotPasswordOtpForm" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="forgot-password-otp">Enter OTP</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput type="text" id="forgot-password-otp" placeholder="Enter your 4 digit OTP" formControlName="otp" required maxlength="4">
        @if (isFieldInvalid('otp')) {
          <mat-error>{{ getFieldError('otp') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="verify-otp-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Verifying...</span>
        } @else {
          <span>Verify OTP</span>
        }
      </button>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="resend-otp-link"
        (click)="onResendForgotPasswordOtp()">
        <span>Resend OTP</span>
      </button>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="back-to-login-link"
        (click)="onBackToLogin()">
        <span>Back to Login</span>
      </button>
    </div>
  </form>
}

<!-- Forgot Password Step 2 Form Content -->
@if (formMode === 'forgotPasswordStep2') {
  <div class="form-header">
    <h3 class="form-title">Reset Password</h3>
  </div>
  
  <form [formGroup]="forgotPasswordStep2Form" (ngSubmit)="onSubmit()" class="form-content">
    <div class="form-group">
      <label for="forgot-password-step2-password">New Password</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput [type]="showPassword ? 'text' : 'password'" id="forgot-password-step2-password" placeholder="Enter your new password" formControlName="password" required>
        <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button" aria-label="Toggle password visibility">
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (isFieldInvalid('password')) {
          <mat-error>{{ getFieldError('password') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="forgot-password-step2-confirm-password">Confirm New Password</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput [type]="showForgotPasswordConfirmPassword ? 'text' : 'password'" id="forgot-password-step2-confirm-password" placeholder="Confirm your new password" formControlName="confirmPassword" required>
        <button mat-icon-button matSuffix (click)="toggleForgotPasswordConfirmPasswordVisibility()" type="button" aria-label="Toggle password visibility">
          <mat-icon>{{ showForgotPasswordConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (isFieldInvalid('confirmPassword')) {
          <mat-error>{{ getFieldError('confirmPassword') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <button 
        mat-raised-button 
        color="primary" 
        class="forgot-password-btn" 
        type="submit"
        [disabled]="!isFormValid() || isLoading">
        @if (isLoading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
          <span>Resetting Password...</span>
        } @else {
          <span>Reset Password</span>
        }
      </button>
    </div>

    <div class="form-group">
      <button 
        type="button"
        class="back-to-login-link"
        (click)="onBackToLogin()">
        <span>Back to Login</span>
      </button>
    </div>
  </form>
}